"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrlFromIds = buildUrlFromIds;
const URL_LIMIT = 2000;
function buildUrlFromIds(path, ids, queryParams = []) {
    const initialPath = `${path}?ids=`;
    const queryParamsPart = queryParams.length ? `&${queryParams.join('&')}` : '';
    const remainingCharacters = URL_LIMIT - initialPath.length - queryParamsPart.length;
    const idLength = ids[0].length + 1; // + 1 for commas
    const idsToTake = Math.floor(remainingCharacters / idLength);
    return `${initialPath}${ids
        .splice(0, idsToTake)
        .join(',')}${queryParamsPart}`;
}
//# sourceMappingURL=buildUrlFromIds.js.map